import { useTranslation } from 'react-i18next'

import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'

interface DeleteAnnouncementConfirmationPopupProps {
  onClose: VoidFunction
  onConfirm: () => Promise<void>
  announcementTitle: string
}

export const DeleteAnnouncementConfirmationPopup = ({
  onClose,
  onConfirm,
  announcementTitle,
}: DeleteAnnouncementConfirmationPopupProps) => {
  const { t } = useTranslation(['communication'])

  const handleConfirm = async () => {
    await onConfirm()
    onClose()
  }

  return (
    <ConfirmationPopup
      confirmText={t('communication:announcements.deleteConfirmation.confirm')}
      title={t('communication:announcements.deleteConfirmation.title')}
      variant="danger"
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Typography>
        {t('communication:announcements.deleteConfirmation.body', {
          title: announcementTitle,
        })}
      </Typography>
    </ConfirmationPopup>
  )
}
